/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

// src/config.js
// Centralized config for environment variables and constants

const BASE_API_URL = process.env.REACT_APP_BASE_API_URL && process.env.REACT_APP_BASE_API_URL !== 'will_be_populated_at_build_time'
    ? process.env.REACT_APP_BASE_API_URL
    : 'https://localhost:7261';

export { BASE_API_URL };
